import React from 'react';
import {ScrollView, View} from 'react-native';
import {noop} from 'lodash';

import {COACH_PROFILE} from '/enum/recordType.enum';

import Mentors from './Mentors';
import Stats from './Stats';
import {styles} from './TeamsTab.style';
import {TeamsTabProps} from './TeamsTab.types';

export const TeamsTab = ({
  coachId = null,
  hasMentors = false,
  onShowRecord = noop,
}: TeamsTabProps) => (
  <ScrollView
    style={styles.base}
    contentContainerStyle={styles.contentContainer}>
    <View style={styles.content}>
      <Stats coachId={coachId} />
      {hasMentors && (
        <Mentors
          // @ts-expect-error TS(2769): No overload matches this call.
          coachId={coachId}
          onMentorCoachPress={({mentorCoachId}: any) =>
            onShowRecord({recordType: COACH_PROFILE, recordId: mentorCoachId})
          }
        />
      )}
    </View>
  </ScrollView>
);

export default TeamsTab;
